import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { initAppSyncClient } from "../../aws/appsync";
import LeaderboardView from "./LeaderboardView";
const getSearchParams = (searchQuery) => {
    const params = new URLSearchParams(searchQuery);
    return {
        screen: params.get("screen"),
        assignment_id: params.get("assignment_id"),
        student_id: params.get("student_id"),
        token: params.get("token")
    }
}
const View = ({ location }) => {
    let { screen, assignment_id, student_id, token } = getSearchParams(location.search);
    const [initilized,setInitilized] = useState(false)
    useEffect(() => {
        const _inithandler = async ()=>{
            await initAppSyncClient(token);
            setInitilized(true)
        }
        _inithandler()
    }, [token])
    useEffect(()=>{
        window.tidioChatApi && window.tidioChatApi.hide();
    },[])
    const renderScreen = () => {
        if (screen === 'leaderboard') {
            return <LeaderboardView session_id={assignment_id}></LeaderboardView>
        }
        return <h1>invalid or expired url</h1>
    }
    return (<div style={{overflow:"scroll"}}>
        {initilized && renderScreen()}
    </div>)
}
export default View;
